import { render, staticRenderFns } from "./ThreeIndex.vue?vue&type=template&id=6f9ef50c&"
import script from "./ThreeIndex.vue?vue&type=script&lang=js&"
export * from "./ThreeIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports